import Ramp from "../models/Ramp";
export const RampMixin = {
  data() {
    return {
      ramp: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Ramp({
          from_currency: undefined,
          on_ramp_operator_id: undefined,
          on_ramp_pair_id: undefined,
          on_ramp_margin: 0,
          asset: undefined,
          decimals: 0,
          off_ramp_operator_id: undefined,
          off_ramp_pair_id: undefined,
          off_ramp_margin: 0,
          to_currency: undefined,
          min_transfer_amount: 0,
          max_transfer_amount: 0,
          max_monthly_transfer: 0,
          welcome_reward: 0,
          service_fee: 0,
          is_active: true,
          is_private: false,
          transfer_time: '2 to 24 working hours',
      })
    }
  }
}
